"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The OpportunitySummary model module.
 * @module model/OpportunitySummary
 * @version 0.0.1
 */
var OpportunitySummary = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>OpportunitySummary</code>.
   * @alias module:model/OpportunitySummary
   */
  function OpportunitySummary() {
    _classCallCheck(this, OpportunitySummary);
    OpportunitySummary.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(OpportunitySummary, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>OpportunitySummary</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OpportunitySummary} obj Optional instance to populate.
     * @return {module:model/OpportunitySummary} The populated <code>OpportunitySummary</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new OpportunitySummary();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('label')) {
          obj['label'] = _ApiClient["default"].convertToType(data['label'], 'String');
        }
        if (data.hasOwnProperty('is_active')) {
          obj['is_active'] = _ApiClient["default"].convertToType(data['is_active'], 'Boolean');
        }
        if (data.hasOwnProperty('open_ts')) {
          obj['open_ts'] = _ApiClient["default"].convertToType(data['open_ts'], 'Date');
        }
        if (data.hasOwnProperty('close_ts')) {
          obj['close_ts'] = _ApiClient["default"].convertToType(data['close_ts'], 'Date');
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} id
 */
OpportunitySummary.prototype['id'] = undefined;

/**
 * @member {String} label
 */
OpportunitySummary.prototype['label'] = undefined;

/**
 * @member {Boolean} is_active
 */
OpportunitySummary.prototype['is_active'] = undefined;

/**
 * @member {Date} open_ts
 */
OpportunitySummary.prototype['open_ts'] = undefined;

/**
 * @member {Date} close_ts
 */
OpportunitySummary.prototype['close_ts'] = undefined;
var _default = exports["default"] = OpportunitySummary;